import axios from 'modules/api-client/request';
import { handleAmazonMessage } from 'modules/api-client/response';

import type {
  ITeeTime,
  ITeeTimeMeta,
  IBookingPriceRequest,
  IBookingPriceResponse,
  ITeeTimesPaymentRequest,
  ITeeTimesPaymentResponse,
} from './types';

import type { IMetaResponse } from '../types';

export const getTeeTimesRequest = (courseId: string, date: string, startTime?: string, cached?: boolean) => {
  return axios
    .get<undefined, IMetaResponse<ITeeTime[], ITeeTimeMeta>>(`/course/${courseId}/tee-times`, {
      params: { cached, date, startTime },
    })
    .catch(handleAmazonMessage);
};

export const sendTeeTimesPaymentRequest = (data: ITeeTimesPaymentRequest) => {
  return axios
    .post<ITeeTimesPaymentRequest, ITeeTimesPaymentResponse>('/course/booking/teetime/pay', data)
    .catch(handleAmazonMessage);
};

export const getBookingPriceRequest = (data: IBookingPriceRequest) => {
  return axios
    .post<IBookingPriceRequest, IBookingPriceResponse>('/course/booking/teetime/get-price', data)
    .catch(handleAmazonMessage);
};

